'use client';
import { SliderStyled } from './slider.styles';

const Slider = SliderStyled;

export default Slider;
